import PropTypes from "prop-types";
import Lomake from "@/components/02-organisms/Lomake";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";
import { map, split, join, slice } from "ramda";

const constants = {
  formLocation: ["kielet", "tutkintokielet"]
};

const Koulutusala = ({
  aktiivisetTutkinnot,
  koulutusalakoodiarvo,
  maaraykset,
  mode,
  sectionId,
  title
}) => {
  const createAllEnglishKieletChangeObjects = () => {
    return map(tutkinto => {
      // Extract the relevant part of the anchor
      const anchorParts = split(".", tutkinto.anchor);
      const relevantPart = join(".", slice(1, 3, anchorParts)); // Get parts ex. 02.1.321141

      // Create the new object structure
      return {
        anchor: `${sectionId}.${relevantPart}.kielet`,
        properties: {
          value: [
            {
              label: "englanti", // You can modify this as needed
              value: "EN" // You can modify this as needed
            }
          ]
        }
      };
    }, aktiivisetTutkinnot);
  };

  const onDeselectAll = () => {
    return map(tutkinto => {
      // Extract the relevant part of the anchor
      const anchorParts = split(".", tutkinto.anchor);
      const relevantPart = join(".", slice(1, 3, anchorParts)); // Get parts ex. 02.1.321141

      // Create the new object structure
      return {
        anchor: `${sectionId}.${relevantPart}.kielet`,
        properties: {
          value: []
        }
      };
    }, aktiivisetTutkinnot);
  };

  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: sectionId
  });

  const lomakedata =
    mode === "modification"
      ? { aktiiviset: aktiivisetTutkinnot }
      : { koulutusalakoodiarvo, maaraykset };
  return (
    <Lomake
      onDeselectAll={onDeselectAll}
      onSelectAll={createAllEnglishKieletChangeObjects}
      selectAll={true}
      anchor={sectionId}
      changeObjects={changeObjects}
      data={lomakedata}
      isRowExpanded={mode === "reasoning"}
      mode={mode}
      path={constants.formLocation}
      rowTitle={title}
      showCategoryTitles={true}
    />
  );
};

Koulutusala.propTypes = {
  aktiivisetTutkinnot: PropTypes.array,
  koodiarvo: PropTypes.string,
  koulutusalakoodiarvo: PropTypes.string,
  maaraykset: PropTypes.array,
  mode: PropTypes.string,
  sectionId: PropTypes.string,
  title: PropTypes.string
};

export default Koulutusala;
